import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $partners,
  $totalCountOfPartners,
  partnersListMounted,
  getPartners,
} from './model'
import { PartnerRequest } from './types'

export const usePartnersList = () => {
  React.useEffect(() => {
    partnersListMounted({
      limit: 10,
      page: 1,
      orderBy: 'id',
      orderDirection: '-',
      searchText: '',
      searchedColumn: '',
    })
  }, [])

  const onChangePartnersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }: PartnerRequest) => {
    partnersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      searchedColumn,
      filters,
    })
  }

  const loading = useStore(getPartners.pending)

  const partners = useStore($partners)
  const totalCountOfPartners = useStore($totalCountOfPartners)

  return { partners, totalCountOfPartners, loading, onChangePartnersList }
}
